function Callback() {
  return <div>Callback Component</div>;
}

export default Callback;
